import React, { useLayoutEffect, useRef, useState, useEffect } from "react";
import TagItem from "./TagItem";
import { _t } from "core/language";

const TagListExpandLimitLine: React.FC<any> = ({
  options,
  value,
  handleTagClick,
  expandLine,
  itemClassName,
  activeClasses,
  inactiveClasses,
}) => {
  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  const [maxHeight, setMaxHeight] = useState<string>("0px");
  const containerRef = useRef<HTMLDivElement | null>(null);
  const expandRef = useRef<HTMLButtonElement | null>(null);
  const [itemCountInLimitRows, setItemCountInLimitRows] = useState<number>(
    options.length
  );
  const [init, setInit] = useState<boolean>(false);

  useEffect(() => {
    setInit(false);
    setItemCountInLimitRows(options.length);
  }, [options])

  // Calculate the max height for 2 rows using Flexbox
  useLayoutEffect(() => {
    if (containerRef.current && !init) {
      const itemHeight = containerRef.current.children[0]?.clientHeight || 0;
      const expandBtnWidth = expandRef.current?.clientWidth || 100;
      const gap = 16; // Tailwind gap-4 = 16px
      const rows = expandLine;
      const itemBorder = 2; // Border width of 1px on top and
      setMaxHeight(`${rows * (itemHeight + itemBorder) + (rows - 1) * gap}px`);

      let containerWidth = containerRef.current.offsetWidth
      // (containerRef.current.offsetWidth * expandLine) - 100;
      let currentWidthSum = 0;
      let totalItemsInFirstTwoRows = 0;
      let rowCount = 0;

      // Iterate over options and sum their widths until we reach the first row and second row
      for (let i = 0; i < options.length; i++) {
        const item = containerRef.current.children[i] as HTMLElement;
        const itemWidth = item.clientWidth + itemBorder;
        
        // If we've exceeded the container width, move to the next row
        if (
          (currentWidthSum + itemWidth) > containerWidth
          || ( // check if the last === expandLine - 1
            (currentWidthSum + itemWidth) < containerWidth
            && (currentWidthSum + itemWidth + gap) > containerWidth
            && rowCount === expandLine - 1
          )
        ) {
          rowCount++;
          if (
            rowCount >= expandLine &&
            totalItemsInFirstTwoRows + 1 !== options.length
          ) {
            setItemCountInLimitRows(totalItemsInFirstTwoRows);
            break; // Stop when we've counted the first two rows
          }
          currentWidthSum = 0; // Start counting for the next row
          if (rowCount ===  expandLine - 1) {
            containerWidth = containerWidth - expandBtnWidth
          }
        }

        currentWidthSum += itemWidth + gap;
        // last item in the list
        if (currentWidthSum > containerWidth) {
          currentWidthSum -= gap
        }
        totalItemsInFirstTwoRows++;

        // console.log({
        //   currentWidthSum,
        //   itemWidth,
        //   containerWidth,
        //   rowCount,
        //   totalItemsInFirstTwoRows,
        //   item,
        //   init,
        // })
      }
      setInit(true)
    }
  }, [init]);

  console.log(options, 'options11');
  
  return (
    <div className="space-y-4">
      {/* Items Container */}
      <div
        ref={containerRef}
        className={`flex flex-wrap gap-4 overflow-hidden transition-all duration-300`}
        style={{ maxHeight: isExpanded ? "none" : maxHeight }}
      >
        {(options || []).map((tag: any, index: number) => (
          <TagItem
            key={tag.id}
            text={tag.text}
            // text={tag.text + " " + itemCountInLimitRows}
            isActive={value.includes(tag.id)}
            onClick={() => handleTagClick(tag)}
            className={itemClassName + (!isExpanded && index >= itemCountInLimitRows ? " hidden" : "")}
            activeClasses={activeClasses}
            inactiveClasses={inactiveClasses}
          />
        ))}

        {/* Toggle Button */}
        <button
          ref={expandRef}
          type="button"
          className={`
            gap-1 self-stretch px-3.5 py-[4px] my-auto text-[13px]
            bg-white border border-solid border-stone-300 rounded-[50px] 
            hover:bg-gray-50 transition-colors duration-200 min-h-[32px] tracking-tighter flex items-center
            ${init ? (itemCountInLimitRows === options.length ? 'hidden' : '') : ''}
          `}
          onClick={() => setIsExpanded((prevState) => !prevState)}
          aria-expanded={isExpanded}
        >
          <span className="text-[13px] text-[#777777]">
            {isExpanded ? _t("main.tag.close") : _t("main.tag.open")}
          </span>{" "}
          <span className="text-[8px] flex items-center pt-[5px] h-[10px]">
            {isExpanded ? "▲" : "▼"}
          </span>
        </button>
      </div>
    </div>
  );
};

export default TagListExpandLimitLine;
